import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export class YesNoToBooleanAdapter implements JsonCustomConvert<boolean> {
    serialize(value: boolean): any {
        return value ? 'Yes' : 'No';
    }

    deserialize(value: any): boolean {
        return value && value === 'Yes';
    }
}
